import type { EntitySection } from '@/lib/entity-sections';

/*
 * Domain knowledge: the sub-sections a provider detail view exposes. Lives in
 * the feature (EntitySectionLayout and lib/entity-sections are domain-free).
 * Ported verbatim from the prototype's `ENTITY_SECTIONS.providers`
 * (public/js/entity-sub-menu.js) so existing deep links keep working; `profile`
 * is the first section and the fallback.
 */
export const providerSections: readonly EntitySection[] = [
  { id: 'profile', label: 'Profile' },
  { id: 'disbursements', label: 'Disbursements' },
  { id: 'distribution-rules', label: 'Distribution Rules' },
  { id: 'reconciliation', label: 'Reconciliation' },
  { id: 'contracts', label: 'Contracts' },
  { id: 'bank-accounts', label: 'Bank Accounts' },
  { id: 'disbursement-schedules', label: 'Disbursement Schedules' },
];
